export const Admin = 'Admin'
export const Finance = 'Finance'
export const CasualInspector = 'Casual Inspector'
export const LeasingConsultant = 'Leasing Consultant'
export const PropertyManager = 'Property Manager'
export const BDM = 'BDM'
export const TeamLeader = 'Team Leader'
